export default "__VITE_ASSET__XY1f6pff__"